import React from 'react';

import { components } from '@atlaskit/select';
import Spinner from '@atlaskit/spinner';

import { LoadingWrapper } from '../../styled';

import { ErrorMessage } from './error-message';
import { LoadingMessage } from './loading-message';
import { ShowMoreButton } from './show-more-button';
import { type MenuListProps } from './types';

export const MenuList = (props: MenuListProps) => {
	const { selectProps } = props;

	/**
	 * the following props are not included in the native MenuList
	 * to pass props to a custom component override without re-rendering,
	 * you must use select props.
	 */

	const isLoading = selectProps?.isLoading;
	const isPaginationLoading = selectProps?.isPaginationLoading;
	const onShowMore = selectProps?.onShowMore;
	const hasNextPage = selectProps?.hasNextPage;
	const isError = selectProps?.isError;
	const onRetry = selectProps?.onRetry;

	return (
		<components.MenuList {...props}>
			{isLoading && <LoadingMessage />}
			{!isLoading && isError && <ErrorMessage onRetry={onRetry} />}
			{!isLoading && !isError && (
				<>
					{props.children}
					{isPaginationLoading && (
						<LoadingWrapper>
							<Spinner testId="pagination-loader" />
						</LoadingWrapper>
					)}
					{hasNextPage && !isPaginationLoading && onShowMore && (
						<ShowMoreButton onShowMore={onShowMore} />
					)}
				</>
			)}
		</components.MenuList>
	);
};
